export default () => {
  const commit = process.env.REACT_APP_COMMIT;
  const buildDate = process.env.REACT_APP_BUILD_DATE;
  return `NewChart Booking System: Commit: ${commit} / Build Date: ${buildDate}\n`;
};
